import { Typography } from '@mui/material';
import { Fragment, useMemo } from 'react';
import { TableV4, PaginationV3, CardV1 } from 'gf-ui-components-mui-lib';
import { clientTableContent } from '../../organisms/generateClient/constants';
import { useTableContext } from '../../../context/tableContext';
import styles from '../../organisms/generateClient/styles.module.scss';

const ClientConfirmationHeader = () => {
  return (
    <Typography
      sx={{
        color: '#344054',
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
        textTransform: 'uppercase',
        textAlign: 'center',
        background: 'var(--gray-25, #FCFCFD)',
        padding: '12px',
      }}
    >
      DynaChrg notice of shipment
    </Typography>
  );
};
const ClientDetails = ({
  clientFormData,
}: {
  clientFormData: {
    clientOrderNum: string;
    clientName: string;
    address: string;
    notes: string;
  };
}) => {
  const {
    clientRowsPerPage,
    clientPage,
    setClientRowsPerPage,
    setClientPage,
    showGenerate,
    selectedWareHouseRowsWithPage,
  } = useTableContext();
  const clientDetailLabel = {
    color: '#344054',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
  };

  const clientTable = useMemo(() => {
    if (selectedWareHouseRowsWithPage?.length > 0) {
      const wareHouseElements = selectedWareHouseRowsWithPage?.map(
        (item: any, index: number) => {
          return Object.values(item);
        }
      );

      const updatedWarehouseRows = wareHouseElements
        .reduce((accumulator: any, currentArray: any) => {
          return accumulator.concat(currentArray);
        }, [])
        .reduce((accumulator: any, currentArray: any) => {
          return accumulator.concat(currentArray);
        }, []);

      return updatedWarehouseRows?.map((item: any) => {
        return {
          ...item,
          clientOrderNum: clientFormData?.clientOrderNum,
        };
      });
    }
  }, [selectedWareHouseRowsWithPage, clientFormData]);

  return (
    <div className={`${styles.padding}`}>
      {' '}
      <div className={`${styles.clientDetails}`}>
        <div className={`${styles.clientField}`}>
          <Typography sx={clientDetailLabel}>Client Name</Typography>
          <p className={`${styles.clientResponse}`}>
            {clientFormData?.clientName ? (
              clientFormData?.clientName
            ) : (
              <span className={`${styles.defaultText}`}>Enter Client Name</span>
            )}
          </p>
        </div>
        <div className={`${styles.clientField}`}>
          <Typography sx={clientDetailLabel}>Address</Typography>
          <p className={`${styles.clientResponse}`}>
            {clientFormData?.address ? (
              clientFormData?.address
            ) : (
              <span className={`${styles.defaultText}`}>Enter Address</span>
            )}
          </p>
        </div>
        <div className={`${styles.clientField}`}>
          <Typography sx={clientDetailLabel}>Notes</Typography>
          <p className={`${styles.clientResponse}`}>
            {clientFormData?.notes ? (
              clientFormData?.notes
            ) : (
              <span className={`${styles.defaultText}`}>
                Enter Client Notes
              </span>
            )}
          </p>
        </div>
      </div>
      <TableV4
        paperStyle={true}
        cols={clientTableContent}
        data={clientTable}
        rowsPerPage={clientRowsPerPage}
        page={clientPage}
        clientPage={clientPage}
        clientRowsPerPage={clientRowsPerPage}
        setClientRowsPerPage={setClientRowsPerPage}
        setClientPage={setClientPage}
        showGenerate={showGenerate}
        sx={{
          overflow: 'auto',
          flex: 1,
          '& .MuiTableHead-root': {
            '& .MuiTableCell-root': {
              padding: '12px 24px',
              borderBottom: '1px solid var(--gray-200, #EAECF0)',
              background: 'var(--gray-100, #F5F5F5)',
              textTransform: 'uppercase',
              textAlign: 'center',
              '& .MuiTypography-root': {
                fontFamily: 'Poppins !important',
                fontSize: '14px !important',
                lineHeight: '24px !important',
                fontWeight: '500 !important',
                color: '#051433 !important',
              },
            },
          },
          '& .MuiTableBody-root': {
            '& .MuiTableCell-root': {
              padding: '12px 24px',
              borderRight: '1px solid var(--gray-200, #EAECF0)',
              textAlign: 'center',
              borderBottom: '1px solid var(--gray-200, #EAECF0)',
              '& .MuiTypography-root': {
                fontFamily: 'Poppins !important',
                fontSize: '14px !important',
                lineHeight: '24px !important',
                fontWeight: '400 !important',
                color: '#051433 !important',
              },
            },
          },
        }}
      />
    </div>
  );
};

const FootNote = () => {
  const {
    clientPage,
    setClientPage,
    clientRowsPerPage,
    setClientRowsPerPage,
    page,
    rowsPerPage,
    tableData,
    setPage,
    setRowsPerPage,
    resultCount,
    showGenerate,
    showNext,
    wareHouseStatusRows,
    selectedWareHouseRowsWithPage,
    generateRowsDisplayPerPage,
    setGenerateRowsDisplayPerPage,
    wareHouseTablePage,
    setWareHouseTablePage,
    wareHouseRowsResultCount,
  } = useTableContext();

  const updatedWarehouseRows = selectedWareHouseRowsWithPage
    ?.map((item: any, index: number) => {
      return Object.values(item);
    })
    .reduce((accumulator: any, currentArray: any) => {
      return accumulator.concat(currentArray);
    }, [])
    .reduce((accumulator: any, currentArray: any) => {
      return accumulator.concat(currentArray);
    }, []);

  return (
    <div style={{ marginTop: "-10px", marginRight: "-9px" }}>
      <PaginationV3
        {...{
          rowsPerPageOptions: [10, 15, 25, 50, 100],
          setClientPage: setClientPage,
          variant: "outlined",
          clientPage: clientPage,
          clientRowsPerPage: clientRowsPerPage,
          selectedWareHouseRows: updatedWarehouseRows,
        }}
        paginationDisplay={{
          position: "relative",
          zIndex: 200,
          paddingLeft: "32px",
          paddingRight: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "var(--gray-100, #F5F5F5)",
        }}
        showGenerate={showGenerate}
        resultCount={resultCount}
        // clientPage={clientPage}
        generateRowsDisplayPerPage={generateRowsDisplayPerPage}
        showNext={showNext}
        wareHouseTablePage={wareHouseTablePage}
        wareHouseRowsResultCount={wareHouseRowsResultCount}
        selectedWareHouseRows={updatedWarehouseRows}
        page={page}
        setPage={setPage}
        tableData={tableData}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        wareHouseStatusRows={wareHouseStatusRows}
        // setClientPage={setClientPage}
        setGenerateRowsDisplayPerPage={setGenerateRowsDisplayPerPage}
        setWareHouseTablePage={setWareHouseTablePage}
        clientRowsPerPage={clientRowsPerPage}
        setClientRowsPerPage={setClientRowsPerPage}
        isTablePagination
      />
      <Typography
        sx={{
          borderBottom: "1px solid var(--gray-200, #EAECF0)",
          background: "var(--warning-300, #FFBE4D)",
          paddingRight: 0,
          color: "#051433",
          fontFamily: "Poppins",
          fontSize: "16px",
          lineHeight: "24px",
          fontWeight: 500,
          textAlign: "center",
          padding: "12px 0",
          // position: "static !important",
        }}
      >
        Please confirm the information and click on “generate” to proceed
      </Typography>
    </div>
  );
};
export const ClientConfirmation = ({
  clientFormData,
}: {
  clientFormData: {
    clientOrderNum: string;
    clientName: string;
    address: string;
    notes: string;
  };
}) => {
  return (
    <Fragment>
      <CardV1
        sx={{
          flex: 1,
          zIndex: 10,
          // maxHeight: "87vh",
          boxShadow:
            '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14) !important',
          height: 'calc(100vh - 90px)',
          padding: 0,
        }}
        bottomPadding={false}
        rightPadding={true}
        header={<ClientConfirmationHeader />}
        children={<ClientDetails clientFormData={clientFormData} />}
        footer={
          <>
            {' '}
            <FootNote />
          </>
        }
      />
    </Fragment>
  );
};
